import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Loading from 'components/Loading'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
// import { getPageHtmlContent, syncPartnerHierarchyDBUpdate } from 'actions/partnerPlans'
import { syncPartnerHierarchyDBUpdate } from 'actions/partnerPlans'
import { getCurrentOverviewPage } from 'actions/partnerPlanAdmin'
// import { getConfig } from 'utils/config'
import PropTypes from 'prop-types'
import FeatureGuard from '../components/FeatureToggle/FeatureGuard'

class PartnerPlanOverview extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    // getPageHtmlContent: PropTypes.func.isRequired,
    getCurrentOverviewPage: PropTypes.func.isRequired,
    // syncPartnerHierarchyDBUpdate: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { currentUser } = this.props
    // this.props.getPageHtmlContent(getConfig().PAGE_TEMPLATE_LIBRARY, 'PartnerPlan', currentUser.EmployeeId)
    this.props.getCurrentOverviewPage(currentUser.EmployeeId)
    // this.props.syncPartnerHierarchyDBUpdate(currentUser.EmployeeId)
  }

  render() {
    const { currentUser } = this.props
    if (this.props.partnerPlanAdmin.isFetching) {
      return (<Loading pageLoading />)
    }

    return (
      <FeatureGuard featureName="Plan" user={currentUser}>
        <p
        // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
          __html: this.props.partnerPlanAdmin.partnerPlanOverviewPage.pagebody,
        }}
        />
      </FeatureGuard>
    )
  }
}

const mapStateToProps = state => ({
  partnerPlans: state.partnerPlans,
  partnerPlanAdmin: state.partnerPlanAdmin,
  errorMessage: state.errorMessage,
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  // getPageHtmlContent,
  getCurrentOverviewPage,
  // syncPartnerHierarchyDBUpdate,
})(PartnerPlanOverview))



// WEBPACK FOOTER //
// ./src/containers/PartnerPlanOverview.js